module.exports = __webpack_public_path__ + "static/media/profile-mobile.46633349.jpg";